import { Node, mergeAttributes } from '@tiptap/core'

/**
 * Video embed placeholder. Only the video URL is stored
 * (<div data-rich-text-embed="..." data-provider="...">) - the iframe is
 * created server side for whitelisted providers only. Inside the editor a
 * simple preview box is shown, no third party content is loaded.
 *
 * The URL match patterns are provided by the server (each EmbedProvider's
 * clientPattern(), passed via editorSettings.embeds) - a single source of
 * truth that also covers host-registered custom providers.
 */
export default Node.create({
  name: 'richTextEmbed',

  group: 'block',
  atom: true,

  addAttributes() {
    return {
      url: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-rich-text-embed'),
        renderHTML: (attributes) => ({ 'data-rich-text-embed': attributes.url }),
      },
      provider: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-provider'),
        renderHTML: (attributes) => ({ 'data-provider': attributes.provider }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-rich-text-embed]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('div')
      dom.className = 'rich-text-embed-preview'

      const label = document.createElement('span')
      label.className = 'rich-text-embed-preview-provider'
      label.textContent = node.attrs.provider || 'video'

      const url = document.createElement('span')
      url.className = 'rich-text-embed-preview-url'
      url.textContent = node.attrs.url || ''

      dom.append(label, url)

      return { dom }
    }
  },

  addCommands() {
    return {
      insertEmbed:
        (url, provider) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { url, provider } }),
    }
  },
})
